<template>
  <modal :state="state" :index="index" @toggle-modal="hideOrReturn" :should-cancel-on="!isSaving">
    <div class="organization-modal" :slot="ModalStatus.Confirmation">
      <h3 class="modal-title">Create organization</h3>

      <flash-attribute-messages v-if="errors" :messages="errors"></flash-attribute-messages>

      <div>
        <div>
          <label for="organization-name">Name organization</label>
          <input id="organization-name" type="text" v-model="name" @keydown.enter="createOrg">
        </div>

        <div>
          <label for="organization-subdomain">Subdomain</label>
          <row class="component-row">
            <column>
              <input id="organization-subdomain" class="align-right" type="text" v-model="subdomain" @keydown.enter="createOrg">
            </column>
            <suffix>
              <pencil color="Inherit">.Formability.com</pencil>
            </suffix>
          </row>
        </div>
      </div>

      <div class="cta">
        <button type="button" class="btn red outline block" data-dismiss="modal" @click="hideOrReturn" :disabled="isSaving">Cancel</button>
        <button type="button" class="btn green block"
                @click="createOrg"
                :disabled="!isValidOrganization || isSaving">
          Create
        </button>
      </div>
    </div>
    <div :slot="ModalStatus.InProgress">
      <h3 class="modal-title">Creating organization...</h3>
      <p>This will take just a second.</p>
    </div>
  </modal>
</template>

<script lang="ts">
  import Vue from "vue";
  import Organization from "../../../models/organization";
  import GloballySelected from "../../../state/modules/globallySelected";
  import {RegexHelper} from "../../../helpers/regexHelper";
  import FlashAttributeMessages from "../../flash/flash-attribute-messages.vue";

  export default Vue.extend({
    components: {FlashAttributeMessages},
    props: {
      state: Object,
    },
    data: function () {
      return {
        isSaving: false,
        name: '',
        subdomain: '',
        errors: null,
      }
    },
    computed: {
      isValidOrganization(): boolean {
        return RegexHelper.presence.test(this.name) && RegexHelper.isValidSubdomain(this.subdomain);
      }
    },
    methods: {
      createOrg(): void {
        if (this.isValidOrganization) {
          let organization = new Organization();
          organization.name = this.name;
          organization.subdomain = this.subdomain;
          this.isSaving = true;
          this.state.status = this.ModalStatus.InProgress;
          organization.save().then(([data]) => {
            if (data.success) {
              GloballySelected.organization.set(organization);
              this.errors = null;
              window.location.href = organization.url;
            } else {
              this.isSaving = false;
              this.state.status = this.ModalStatus.Confirmation;
              if (data.errors && data.errors.subdomain) {
                this.errors = data.errors.subdomain.map(e => `Subdomain ${e}`);
              } else {
                this.errors = ['Could not create the organization. Please try again later.'];
              }
            }
          }).catch(() => {
            this.state.status = this.ModalStatus.Confirmation;
            this.isSaving = false;
          });
        }
      },
    }
  });

</script>